import { RG_TYPE as t, RG_TECH_CLASS as a } from "@project-rouge/rg-core";
const n = (e) => e.type !== t.TechnicalSpace ? !1 : e.data.instance.spaceClass === a.Amenity;
export {
  n as isAmenityTechSpace
};
//# sourceMappingURL=index.js.map
